module.exports = __webpack_public_path__ + "img/group.5c5ee5fa.png";